import { CharField, NumberField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Faq } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function FaqForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Faq>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Domanda"
        layout="horizontal"
        value={values.question || ""}
        onChange={(value) => {
          setFieldValue("question", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "question") : undefined}
        errorMessage={getIn(errors, "question")}
        required
      />

      <WysiwygField
        label="Risposta"
        layout="horizontal"
        value={values.answer || ""}
        onChange={(value) => {
          setFieldValue("answer", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "answer") : undefined}
        errorMessage={getIn(errors, "answer")}
        required
      />

      <NumberField
        label="Ordine"
        layout="horizontal"
        value={values.order || 0}
        onChange={(value) => {
          setFieldValue("order", value)
        }}
      />
    </Col>
  )
}
